import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'
import {
	AnalyticsExportService,
	ExportTransactionSummaryCsvRequest,
} from '../services/AnalyticsExportService'

export const useMutationExportTransactionSummaryCsv = () => {
	return useMutation({
		mutationFn: (params: ExportTransactionSummaryCsvRequest) =>
			AnalyticsExportService.exportTransactionSummaryCsv(params),
		onSuccess: () => {
			toast.success('ดาวน์โหลดไฟล์ CSV สำเร็จ')
		},
		onError: () => {
			toast.error('เกิดข้อผิดพลาดในการดาวน์โหลดไฟล์ CSV')
		},
	})
}
